import React from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormValidation from "../../../components/FormValidation/FormValidation";
import formFields from "../../../config/formFields.json";
import { useParams } from "react-router-dom";

const AddProjectResourceMapping = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  projects = [],
  resources = [],
  roles = []
}) => {
  const isEdit = !!initialData?.project_resource_mapping_id;
  const id=useParams()?.id;
  const initialValues = {
    resource_id: initialData?.resource_id?.toString() || "",
    project_id:
      initialData?.project_id?.toString() || null,
    role_id: initialData?.role_id?.toString() || null,
    allocation: initialData?.allocation || "",
    start_date: initialData?.start_date || null,
    end_date: initialData?.end_date || null,
    billability: initialData?.is_active ?? true,
    is_active: initialData?.is_active ?? true,
  };

  const getOptionsForField = (fieldName) => {
    switch (fieldName) {
      case "resource_id":
        return resources.map((resource) => ({
          value: resource.resource_id.toString(),
          label: `${resource.first_name} ${resource.last_name}`,
        }));
      case "project_id":
        return projects.map((project) => ({
          value: project.project_id.toString(),
          label: project.project_name,
        }));
      case "role_id":
        return roles.map((role) => ({
          value: role.role_id.toString(),
          label: role.role_name,
        }));
      default:
        return [];
    }
  };

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields[id?'projectMember':'projectResourceMapping'].basic.fields}
      title={id?"Member":"Project Resource Mapping"}
      icon={AssignmentIcon}
      getOptionsForField={getOptionsForField}
      isEdit={isEdit}
      modelWidth={"55vw"}
      moduleName="projectResourceMapping"
    />
  );
};

export default AddProjectResourceMapping;
